const cookieVal = document.cookie.split('; ').find(row => row.startsWith('cookiepreferences='));

// Setuip defaults
let cookiePreferences = {
    analytics: false,
    advertising: false
};

if (cookieVal) {
    // Check if preferences cookie exists and overwrite preferences var with saved settings
    cookiePreferences = JSON.parse(cookieVal.split('=')[1]);
}

export { cookiePreferences };